export default "__VITE_ASSET__BXpZkNe1__"